export const EXCMTASK_DELETE_RESET = 'EXCMTASK_DELETE_RESET'
export const EXCMTASK_DELETE_SET_ERROR = 'EXCMTASK_DELETE_SET_ERROR'
export const EXCMTASK_DELETE_SET_DELETED = 'EXCMTASK_DELETE_SET_DELETED'
export const EXCMTASK_DELETE_TOGGLE_LOADING = 'EXCMTASK_DELETE_TOGGLE_LOADING'
